import PropTypes from 'prop-types'
import { sToTime } from '@/lib/utils'
import { Button } from '@/components'
import { useTimeout } from '@/hooks'

function ResendCode({ onClick, forceEnable = false, resendCoolDown = 120 }) {
  const [timer, setTimer] = useTimeout(resendCoolDown)

  const handleOnClick = () => {
    onClick()
    setTimer(resendCoolDown)
  }

  // Allow resend if timer is 0 or if forceEnable is true (for session expiry cases)
  const isEnabled = timer === 0 || forceEnable

  return (
    <div className="flex flex-row">
      <Button
        id="resend-code-button"
        aria-label="Resend code"
        variant="link"
        size="text"
        className="p-0 m-0 h-min text-[--brand-500] font-inter font-semibold text-base leading-6 tracking-normal"
        onClick={handleOnClick}
        disabled={!isEnabled}
      >
        Resend Code
      </Button>
      {timer > 0 && !forceEnable ? <p className="text-[--neutral-700]">&nbsp;in {sToTime(timer)}</p> : null}
    </div>
  )
}

ResendCode.propTypes = {
  onClick: PropTypes.func,
  forceEnable: PropTypes.bool,
  resendCoolDown: PropTypes.number,
}

export default ResendCode
